import type {ThemeBreakpoints} from '_uiComponents'

const productList = {
    ProductList: {
        baseStyle: ({headerSize, headerSizeCollapsed}: {headerSize: ThemeBreakpoints; headerSizeCollapsed: ThemeBreakpoints}) => ({
            wrapper: {
                w: '100%',
                alignItems: 'flex-start',
                px: {base: '0', xl: 'spacing.4'},
                gap: 0,
            },
            headingWrapper: {
                alignItems: 'center',
                flexDir: {base: 'row', md: 'column'},
                py: {base: 'spacing.1', md: 0},
            },
            fullWidthTile: {
                colSpan: 2,
                px: {base: 0, md: '20%'},
            },
            horizontalDeviceWidthTile: {
                colSpan: 2,
                px: 0,
                mx: {base: '-spacing.4', xl: '-spacing.8'},
            },
            horizontalWidthTile: {
                colSpan: 2,
                px: 0,
            },
            container: {
                pt: {
                    base: `${headerSize.base}px`,
                    sm: `${headerSize.sm}px`,
                    md: `${headerSize.md}px`,
                    lg: `${headerSize.lg}px`,
                    xl: `${headerSize.xl}px`,
                    '2xl': `${headerSize['2xl']}px`,
                },
            },
            fullWidth: {
                mx: '-spacing.4',
            },
            gridItem: {
                minHeight: 0,
                minWidth: 0,
            },
            filtersButtonWrapperSticky: {
                px: {base: 'spacing.4', xl: 'spacing.8'},
                background: 'color.border.white',
                zIndex: 'dropdown',
                position: 'sticky',
                top: {
                    base: `${headerSizeCollapsed.base}px`,
                    sm: `${headerSizeCollapsed.sm}px`,
                    md: `${headerSizeCollapsed.md}px`,
                    lg: `${headerSizeCollapsed.lg}px`,
                    xl: `${headerSizeCollapsed.xl}px`,
                    '2xl': `${headerSizeCollapsed['2xl']}px`,
                },
            },
            filtersButtonContainer: {
                w: '100%',
                justifyContent: 'flex-end',
                borderBottom: {base: 'none', md: '1px solid'},
                borderBottomColor: {base: 'none', md: 'color.border.grey.300'},
            },
            filtersButton: {
                w: 'auto',
            },
        }),
    },
}

export default productList
